<template>
  <kanbanWrap>
    <kanbanselect-group @groups="groups"></kanbanselect-group>
    <Row :gutter="16">
      <Col span="16">
        <div class="block" style="height: 600px; position: relative">
          <ecmap ref="ecmap"></ecmap>
          <mapMenu @mapData="reMapMenu" ref="mapMenu"></mapMenu>
        </div> </Col
      ><Col span="8">
        <div class="block" style="height: 320px">
          <h2 class="title">
            派工项目统计<startEnd
              @startend="$refs.paigongxiangmu.reach($event)"
            ></startEnd>
          </h2>
          <div class="chartWrap">
            <paigongxiangmu ref="paigongxiangmu"></paigongxiangmu>
          </div>
        </div>
        <div class="block" style="height: 260px">
          <h2 class="title">
            最近派工总览<startEnd
              @startend="$refs.paigongzonglan.reach($event)"
            ></startEnd>
          </h2>
          <div class="chartWrap">
            <paigongzonglan ref="paigongzonglan"></paigongzonglan>
          </div>
        </div>
      </Col>
    </Row>
    <Row :gutter="16">
      <Col span="8">
        <div class="block" style="height: 330px">
          <h2 class="title">作业车辆作业统计</h2>
          <div class="chartWrap">
            <saodiche></saodiche>
          </div>
        </div> </Col
      ><Col span="8">
        <div class="block" style="height: 330px">
          <h2 class="title">巡查车辆作业统计</h2>
          <div class="chartWrap">
            <xunchache ref="pie"></xunchache>
          </div>
        </div> </Col
      ><Col span="8">
        <div class="block" style="height: 330px">
          <h2 class="title">
            作业异常报警<startEnd
              @startend="$refs.cheliangbaojing.reach($event)"
            ></startEnd>
          </h2>
          <div class="chartWrap">
            <cheliangbaojing ref="cheliangbaojing"></cheliangbaojing>
          </div>
        </div>
      </Col>
    </Row>
  </kanbanWrap>
</template>
<script>
import startEnd from "./statrEnd.vue";
import kanbanWrap from "../kanbanWrap.vue";
import youhao from "./youhao.vue";
import licheng from "./licheng.vue";
import xunchache from "./xunchache.vue";
import saodiche from "./saodiche.vue";
import zongzichan from "./pie";
import ecmap from "./ecmap.vue";
import paigongzonglan from "./paigongzonglan.vue";
import cheliangbaojing from "./cheliangbaojing.vue";
import paigongxiangmu from "./paigongxiangmu.vue";
import mapMenu from "./mapMenu.vue";
import kanbanselectGroup from "./kanbanselectGroup.vue";
export default {
  components: {
    zongzichan,
    startEnd,
    kanbanWrap,
    youhao,
    licheng,
    xunchache,
    saodiche,
    ecmap,
    paigongzonglan,
    cheliangbaojing,
    paigongxiangmu,
    mapMenu,
    kanbanselectGroup,
  },

  data() {
    return {};
  },
  methods: {
    reMapMenu(v, m) {
      if (m == "巡查点") {
        setTimeout(() => {
          this.$refs.ecmap.showLjt(v);
        }, 1500);
      } else if (m == "作业人员") {
        setTimeout(() => {
          this.$refs.ecmap.showpersons(v);
        }, 1500);
      } else if (m == "作业车辆") {
        setTimeout(() => {
          this.$refs.ecmap.showXisao(v);
        }, 1500);
      } else if (m == "作业网格") {
        this.$refs.ecmap.showWangge(v);
      } else if (m == "巡查车辆") {
        setTimeout(() => {
          this.$refs.ecmap.showQingyun(v);
        }, 1500);
      } else if (m == "作业线路") {
        setTimeout(() => {
          this.$refs.ecmap.showline(v);
        }, 500);
      }
    },
    groups(v) {
      if (v[0].name == "广东华政建设有限公司") {
        v = [];
      }
      this.$refs.paigongxiangmu.groups(v);
      this.$refs.paigongzonglan.groups(v);
      //this.$refs.licheng.groups(v);
      //this.$refs.youhao.groups(v);
      //this.$refs.zongzichan.groups(v);
      this.$refs.mapMenu.groups(v);
    },
  },
  mounted() {},
};
</script>

<style lang="">
#big {
  width: 1920px;
  height: 1080px;
  padding: 0 16px;
  transform-origin: 0 0;
}
#big p,
#big div {
  color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/components/kanban/carlook/index.vue